/* src/components/PageControl/PageControl.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	subscribe,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Icon from "../Icon";
import Icons from "../Icons";
import Button from "../Button";

function create_default_slot_5(ctx) {
	let icons_left;
	let current;
	icons_left = new Icons.Left({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_left.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_left, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_left_changes = {};
			if (dirty & /*theme*/ 1) icons_left_changes.theme = /*theme*/ ctx[0];
			icons_left.$set(icons_left_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_left.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_left.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_left, detaching);
		}
	};
}

// (53:2) <Button class="prev" {name} {theme} disabled={prev_disabled} on:click={prevPage} content={t.prev}>
function create_default_slot_4(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.prev[/*type*/ ctx[5]],
				alt: "[prev]",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 34) icon_changes.src = /*icons*/ ctx[1]?.prev[/*type*/ ctx[5]];

			if (dirty & /*$$scope, theme*/ 262145) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (61:4) {:else}
function create_else_block(ctx) {
	let t0_value = /*$index*/ ctx[4] + 1 + "";
	let t0;
	let t1;
	let t2;

	return {
		c() {
			t0 = text(t0_value);
			t1 = text("/");
			t2 = text(/*$length*/ ctx[3]);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, t2, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*$index*/ 16 && t0_value !== (t0_value = /*$index*/ ctx[4] + 1 + "")) set_data(t0, t0_value);
			if (dirty & /*$length*/ 8) set_data(t2, /*$length*/ ctx[3]);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
		}
	};
}

// (59:4) {#if $index == null || $length == null}
function create_if_block(ctx) {
	let t_1;

	return {
		c() {
			t_1 = text("…");
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (66:4) <Icon src={icons?.next[type]} alt="[next]">
function create_default_slot_3(ctx) {
	let icons_right;
	let current;
	icons_right = new Icons.Right({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_right.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_right, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_right_changes = {};
			if (dirty & /*theme*/ 1) icons_right_changes.theme = /*theme*/ ctx[0];
			icons_right.$set(icons_right_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_right.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_right.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_right, detaching);
		}
	};
}

// (65:2) <Button class="next" {name} {theme} disabled={next_disabled} on:click={nextPage} content={t.next}>
function create_default_slot_2(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.next[/*type*/ ctx[5]],
				alt: "[next]",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 34) icon_changes.src = /*icons*/ ctx[1]?.next[/*type*/ ctx[5]];

			if (dirty & /*$$scope, theme*/ 262145) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (71:4) <Icon src={icons?.add[type]} alt="[add]">
function create_default_slot_1(ctx) {
	let icons_whiteboardadd;
	let current;
	icons_whiteboardadd = new Icons.WhiteboardAdd({ props: { theme: /*theme*/ ctx[0] } });

	return {
		c() {
			create_component(icons_whiteboardadd.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icons_whiteboardadd, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icons_whiteboardadd_changes = {};
			if (dirty & /*theme*/ 1) icons_whiteboardadd_changes.theme = /*theme*/ ctx[0];
			icons_whiteboardadd.$set(icons_whiteboardadd_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icons_whiteboardadd.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icons_whiteboardadd.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icons_whiteboardadd, detaching);
		}
	};
}

// (70:2) <Button class="add" {name} {theme} {disabled} on:click={addPage} content={t.add}>
function create_default_slot(ctx) {
	let icon;
	let current;

	icon = new Icon({
			props: {
				src: /*icons*/ ctx[1]?.add[/*type*/ ctx[5]],
				alt: "[add]",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty & /*icons, type*/ 34) icon_changes.src = /*icons*/ ctx[1]?.add[/*type*/ ctx[5]];

			if (dirty & /*$$scope, theme*/ 262145) {
				icon_changes.$$scope = { dirty, ctx };
			}

			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let button0;
	let t0;
	let span;
	let span_class_value;
	let t1;
	let button1;
	let t2;
	let button2;
	let div_class_value;
	let current;

	button0 = new Button({
			props: {
				class: "prev",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*prev_disabled*/ ctx[7],
				content: /*t*/ ctx[10].prev,
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	button0.$on("click", /*prevPage*/ ctx[12]);

	function select_block_type(ctx, dirty) {
		if (/*$index*/ ctx[4] == null || /*$length*/ ctx[3] == null) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	button1 = new Button({
			props: {
				class: "next",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*next_disabled*/ ctx[6],
				content: /*t*/ ctx[10].next,
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button1.$on("click", /*nextPage*/ ctx[13]);

	button2 = new Button({
			props: {
				class: "add",
				name,
				theme: /*theme*/ ctx[0],
				disabled: /*disabled*/ ctx[2],
				content: /*t*/ ctx[10].add,
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	button2.$on("click", /*addPage*/ ctx[14]);

	return {
		c() {
			div = element("div");
			create_component(button0.$$.fragment);
			t0 = space();
			span = element("span");
			if_block.c();
			t1 = space();
			create_component(button1.$$.fragment);
			t2 = space();
			create_component(button2.$$.fragment);
			attr(span, "class", span_class_value = "" + (name + "-text " + /*theme*/ ctx[0]));
			attr(div, "class", div_class_value = "" + (name + " " + /*theme*/ ctx[0]));
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(button0, div, null);
			append(div, t0);
			append(div, span);
			if_block.m(span, null);
			append(div, t1);
			mount_component(button1, div, null);
			append(div, t2);
			mount_component(button2, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const button0_changes = {};
			if (dirty & /*theme*/ 1) button0_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*prev_disabled*/ 128) button0_changes.disabled = /*prev_disabled*/ ctx[7];
			if (dirty & /*t*/ 1024) button0_changes.content = /*t*/ ctx[10].prev;

			if (dirty & /*$$scope, icons, type, theme*/ 262179) {
				button0_changes.$$scope = { dirty, ctx };
			}

			button0.$set(button0_changes);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(span, null);
				}
			}

			if (!current || dirty & /*theme*/ 1 && span_class_value !== (span_class_value = "" + (name + "-text " + /*theme*/ ctx[0]))) {
				attr(span, "class", span_class_value);
			}

			const button1_changes = {};
			if (dirty & /*theme*/ 1) button1_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*next_disabled*/ 64) button1_changes.disabled = /*next_disabled*/ ctx[6];
			if (dirty & /*t*/ 1024) button1_changes.content = /*t*/ ctx[10].next;

			if (dirty & /*$$scope, icons, type, theme*/ 262179) {
				button1_changes.$$scope = { dirty, ctx };
			}

			button1.$set(button1_changes);
			const button2_changes = {};
			if (dirty & /*theme*/ 1) button2_changes.theme = /*theme*/ ctx[0];
			if (dirty & /*disabled*/ 4) button2_changes.disabled = /*disabled*/ ctx[2];
			if (dirty & /*t*/ 1024) button2_changes.content = /*t*/ ctx[10].add;

			if (dirty & /*$$scope, icons, type, theme*/ 262179) {
				button2_changes.$$scope = { dirty, ctx };
			}

			button2.$set(button2_changes);

			if (!current || dirty & /*theme*/ 1 && div_class_value !== (div_class_value = "" + (name + " " + /*theme*/ ctx[0]))) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(button0.$$.fragment, local);
			transition_in(button1.$$.fragment, local);
			transition_in(button2.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button0.$$.fragment, local);
			transition_out(button1.$$.fragment, local);
			transition_out(button2.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(button0);
			if_block.d();
			destroy_component(button1);
			destroy_component(button2);
		}
	};
}

const i18n = {
	en: {
		prev: "Prev Page",
		next: "Next Page",
		add: "Add Page"
	},
	"zh-CN": {
		prev: "\u4E0A\u4E00\u9875",
		next: "\u4E0B\u4E00\u9875",
		add: "\u6DFB\u52A0\u9875\u9762"
	}
};

const name = "fastboard-page-control";

function instance($$self, $$props, $$invalidate) {
	let writable;
	let disabled;
	let t;
	let index;
	let length;
	let prev_disabled;
	let next_disabled;

	let $length,
		$$unsubscribe_length = noop,
		$$subscribe_length = () => ($$unsubscribe_length(), $$unsubscribe_length = subscribe(length, $$value => $$invalidate(3, $length = $$value)), length);

	let $index,
		$$unsubscribe_index = noop,
		$$subscribe_index = () => ($$unsubscribe_index(), $$unsubscribe_index = subscribe(index, $$value => $$invalidate(4, $index = $$value)), index);

	let $writable,
		$$unsubscribe_writable = noop,
		$$subscribe_writable = () => ($$unsubscribe_writable(), $$unsubscribe_writable = subscribe(writable, $$value => $$invalidate(17, $writable = $$value)), writable);

	$$self.$$.on_destroy.push(() => $$unsubscribe_length());
	$$self.$$.on_destroy.push(() => $$unsubscribe_index());
	$$self.$$.on_destroy.push(() => $$unsubscribe_writable());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { icons = void 0 } = $$props;
	let type;

	function prevPage() {
		app?.prevPage();
	}

	function nextPage() {
		app?.nextPage();
	}

	function addPage() {
		app?.addPage({ after: true });
		app?.nextPage();
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(15, app = $$props.app);
		if ('theme' in $$props) $$invalidate(0, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(16, language = $$props.language);
		if ('icons' in $$props) $$invalidate(1, icons = $$props.icons);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 32768) {
			$: $$subscribe_writable($$invalidate(11, writable = app?.writable));
		}

		if ($$self.$$.dirty & /*$writable*/ 131072) {
			$: $$invalidate(2, disabled = !$writable);
		}

		if ($$self.$$.dirty & /*language*/ 65536) {
			$: $$invalidate(10, t = i18n[language]);
		}

		if ($$self.$$.dirty & /*disabled*/ 4) {
			$: $$invalidate(5, type = disabled ? "disable" : "normal");
		}

		if ($$self.$$.dirty & /*app*/ 32768) {
			$: $$subscribe_index($$invalidate(9, index = app?.sceneIndex));
		}

		if ($$self.$$.dirty & /*app*/ 32768) {
			$: $$subscribe_length($$invalidate(8, length = app?.sceneLength));
		}

		if ($$self.$$.dirty & /*disabled, $index*/ 20) {
			$: $$invalidate(7, prev_disabled = disabled || !$index);
		}

		if ($$self.$$.dirty & /*disabled, $length, $index*/ 28) {
			$: $$invalidate(6, next_disabled = disabled || $length == null || $index === $length - 1);
		}
	};

	return [
		theme,
		icons,
		disabled,
		$length,
		$index,
		type,
		next_disabled,
		prev_disabled,
		length,
		index,
		t,
		writable,
		prevPage,
		nextPage,
		addPage,
		app,
		language,
		$writable
	];
}

class PageControl extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			app: 15,
			theme: 0,
			language: 16,
			icons: 1
		});
	}
}

export default PageControl;